import React from "react";
import { withRouter } from 'react-router-dom';
import { Badge,Button,Modal,ModalHeader,ModalBody,
    Form, FormGroup, Label, Input, FormText} from 'reactstrap';
import logo from '../shared/images/datastack_logo_small.png';
import ASR from '../shared/images/ASR.png';
import dashboard from '../shared/images/dashboard.png';
import certification_levels from '../shared/images/certification_levels.png';
import {baseUrl} from '../shared/baseUrl';
class Certification extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            isModalOpen:false,
            certCode:"",
            certError:"",
            buttonText:"Submit",

            // After Getting Results
            name:"",
            email:"",
            gender:"",
            divDisplay:"none"
        }
    }

    myChangeHandler = (event) => {
        // console.log(event.target)
        let nam = event.target.name;
        let val = event.target.value;
        // console.log(nam,val)
        this.setState({[nam]: val});
    }

    mySubmitHandler = () => {
        // console.log("In Submit"+this.state.certCode);
        this.setState({
            name:"",
            email:"",
            gender:"",
            divDisplay:"none",
            certError:"",
        })
        if(this.state.certCode){
            return fetch(baseUrl+'verifyCert/getInfo/'+this.state.certCode,{
                method: 'GET',
                headers: {
                    "Content-Type": "application/json"
                    },
                credentials: 'same-origin'
            })
            .then(response =>response.json())
            .then(response=>{
                console.log(response);
                if(response.success){
                    this.setState({
                        divDisplay:"",
                        name:response.name,
                        email:response.email,
                        gender:response.gender
                    })
                }
                else{
                    if(response.message){
                        this.setState({
                            certError:response.message
                        })
                    }
                    else{
                        this.setState({
                            certError:"Cannot Reach Server!"
                        })
                    }
                }
            })
            .catch((err)=>console.log(err));
        }
        
    }

    toggleModal= ()=> {
        this.setState({
            isModalOpen: !this.state.isModalOpen,
            divDisplay:"none",
            certError:"",
            certCode:""
        });
    }


    render(){
        return(
            <div className="container borderedDiv">
                <div class="mt-2 row">
                    <div className="ml-3">
                        <Button
                            color="primary"
                            // style={{
                            //     backgroundColor:"#76a5afff",
                            //     color:"#ffffff"
                            // }}
                            size="sm"
                            onClick={()=>this.props.history.push("/signup")}
                            >Signup</Button>
                    </div>
                    <div className="ml-1">
                        <Button
                            color="primary"
                            // style={{
                            //     backgroundColor:"#76a5afff",
                            //     color:"#ffffff"
                            // }}
                            size="sm"
                            onClick={()=>this.props.history.push("/login")}
                            >Login</Button>
                    </div>
                    <div className="ml-1">
                        <Button
                            color="danger"
                            // style={{
                            //     backgroundColor:"#76a5afff",
                            //     color:"#ffffff"
                            // }}
                            size="sm"
                            onClick={()=>this.toggleModal()}
                            >Verify Certificate</Button>
                    </div>
                </div>

                <div className="mt-2">
                    <h3 className="changeJustFont">
                        <Badge
                            color="primary"
                            style={{
                                backgroundColor:"#073763ff",
                                color:"#ffffff"
                            }}>
                            Welcome To DataStack!
                        </Badge>
                    </h3>
                </div>
                <div>
                    <h5 className="changeFont">Be part of our <strong>Live Project</strong>.
                    Your work will be a direct part of the Final Production Model.</h5>
                </div>
                <div 
                    className="row justify-content-center"
                    style={{
                        marginTop:0
                    }}>
                    <img src={logo} height="216" width="276"></img>
                </div>

                <div className="mt-4">
                    <div>
                        <h4 className="changeJustFont">
                            <Badge
                                color="primary"
                                style={{
                                    backgroundColor:"#cc4125ff",
                                    color:"#ffffff"
                                }}>
                                What We Do
                            </Badge>
                        </h4>
                    </div>
                    <div>
                        <div>
                            <h5 className="changeFont">
                                We at DataStack are developing a <strong>Hindi ASR (Automatic Speech Recognition) Machine Learning Model</strong>.
                                <br/><br/>To put it simply, a Software that will take in Hindi Audio and produce Hindi Text (Devanagari).
                            </h5>
                        </div>
                        <div  className="row justify-content-center">
                            <img src={ASR} height="100%" width="100%" style={{backgroundColor:"transparent"}}></img>
                        </div>
                        <div className="row justify-content-center">
                            <small className="changeJustFont">Img Credit: Real Python</small>
                        </div>
                    </div>
                </div>

                <div className="mt-4">
                    <div>
                        <h4 className="changeJustFont">
                            <Badge
                                color="primary"
                                style={{
                                    backgroundColor:"#ff9900ff",
                                    color:"#ffffff"
                                }}>
                                Your Role
                            </Badge>
                        </h4>
                    </div>
                    <div>
                        <h5 className="changeFont">
                            To develop a good <strong>Hindi ASR model</strong> (or this Software) we need Content.
                            <br/>Content where you are given a Hindi Sentence and will speak that sentence into the Recorder on the website. 
                            <br/><br/><strong>Simple, Right!</strong> The <strong>Recording Dashboard</strong> looks something like this
                        </h5>
                    </div>
                    <div  className="row justify-content-center mt-2">
                        <img src={dashboard} height="100%" width="100%"></img>
                    </div>
                </div>

                <div className="mt-4">
                    <div>
                        <h4 className="changeJustFont">
                            <Badge
                                color="primary"
                                style={{
                                    backgroundColor:"#93c47dff",
                                    color:"#ffffff"
                                }}>
                                Proof of Work
                            </Badge>
                        </h4>
                    </div>
                    <div>
                        <h5 className="changeFont">
                            Depending on your Level of contribution you will be given a <strong>Verifiable Proof of Work</strong>.
                            <br/><br/>By <strong>Verifiable</strong> we mean, your Interviewer or Professor can verify the Certificate on our Website here:  
                            <a href="javascript:void(0)" onClick={()=>this.toggleModal()}> [Verify]</a>.
                            <br/>The Verification process if Full Proof preventing any kind of duplication.
                        </h5>
                    </div>
                    <div>
                        <h5 className="changeFont">
                            Here are the Different Levels of Certification:
                        </h5>
                        <div  className="row justify-content-center mt-2">
                            <img src={certification_levels} height="100%" width="100%"></img>
                        </div>
                        {/* <div className="mt-2">
                            <h5 className="changeFont">
                                Download a Sample Proof of Work [here]. You can Verify it [here]
                            </h5>
                        </div> */}
                    </div>
                    <div className="mt-4">
                        <div>
                            <h4 className="changeJustFont">
                                <Badge
                                    color="primary"
                                    style={{
                                        backgroundColor:"#76a5afff",
                                        color:"#ffffff"
                                    }}>
                                    Final Words
                                </Badge>
                            </h4>
                        </div>
                        <div>
                            <h5 className="changeFont">
                                Your Time Matters, Your Effort Matters, Your Contribution Matters
                                <br/>Here Your Voice can make a difference. Quite Literally! :) 
                            </h5>
                        </div>
                    </div>
                </div>

                <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>Terms And Conditions</ModalHeader>
                    <ModalBody>
                        <Form  onSubmit={this.mySubmitHandler}>
                            <FormGroup >
                                <Label className="required" for="name">Certificate Code</Label>
                                <Input
                                    id="certCode"
                                    type='text'
                                    name='certCode'
                                    onChange={this.myChangeHandler}
                                    value={this.state.certCode}
                                />
                            <FormText color="danger">{this.state.certError}</FormText>
                            </FormGroup>
                        </Form>
                        <div style={{display:this.state.divDisplay}}>
                            <h4 className="changeJustFont"><Badge color="primary">Owner Of Certificate</Badge></h4>
                            <h4 className="changeFont">Name: {this.state.name}</h4>
                            <h4 className="changeFont">Email: {this.state.email}</h4>
                            <h4 className="changeFont">Gender: {this.state.gender}</h4>
                        </div>
                        <div className="row m-auto">
                            <div>
                                <Button
                                color="primary"
                                onClick={this.mySubmitHandler}
                                >Submit</Button>
                            </div>
                            <div className="ml-2">
                                <Button
                                onClick={()=>{
                                    this.setState({
                                        isModalOpen:!this.state.isModalOpen
                                    })
                                }}
                                >Close</Button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}

export default withRouter(Certification);